export const CHECKOUT_URL =
  'https://stretching-instructor-ready.impultienda.ar/checkout'

export function trackCheckout() {
  const fbq = (
    window as Window & {
      fbq?: (...args: unknown[]) => void
    }
  ).fbq
  fbq?.('track', 'InitiateCheckout', {
    content_name: 'Stretching Instructor Ready',
    value: 27,
    currency: 'USD',
  })
}
